import { FC } from 'react';

import {    
  InspectionSetupForm,
  SubmitInspectionForm,
  InspectionApprovalForm,
  SubmitNoteResponseForm,
  SubmitActualROIForm
} from './forms'
import { DLMROI } from '../../../core/doclabel';

type Props = {
  siteID: number
  siteState: string
  appID: number
  siteROIS: Array<DLMROI>
  workflow: string
  doClose: Function    
}

const SiteInspectionResponseForm: FC<Props> = ({siteID, siteState, siteROIS, appID, workflow, doClose}) => {
  
  return(
  <div id='kt_dlm_site_inspection_response_form' className='form'>
    <div
      className='d-flex flex-column p-2'            
    >    
      { siteState === 'Site Labelling Setup' &&
      <InspectionSetupForm id={siteID} appID={appID} doClose={doClose} />
      }
      { siteState === 'Site Labelling' &&
      <SubmitInspectionForm id={siteID} appID={appID} rois={siteROIS} doClose={doClose} />
      }
      { siteState === 'Site Labelling Approved' &&
      <InspectionApprovalForm id={siteID} appID={appID} rois={siteROIS} doClose={doClose} />
      }
      { siteState === 'Applicant Signed' && 
      <SubmitNoteResponseForm id={siteID} state={siteState} workflow={workflow} appID={appID} rois={siteROIS} doClose={doClose} hasVerdict={true} />
      }
      { siteState === 'ROI Pending SCDF Verification' &&
      <SubmitActualROIForm id={siteID} appID={appID} rois={siteROIS} doClose={doClose} />
      }
    </div>
  </div>    
  )      
}

export {SiteInspectionResponseForm}
